/* unplugin-vue-components disabled */import { render } from "./BaseLogin.vue?vue&type=template&id=3bf86f06&scoped=true"
import script from "./BaseLogin.vue?vue&type=script&lang=js"
export * from "./BaseLogin.vue?vue&type=script&lang=js"

import "./BaseLogin.vue?vue&type=style&index=0&id=3bf86f06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf86f06"]])

export default __exports__